<script>
import isMobile from '../utils/isMobile'

export default {
	name: 'ArticleSlider',
	props: {
		id: { type: String, default: "3" },
	},
	created() {
		this.slides = require(`../data/slider${this.id}`).default
		this.totalSlides = this.slides.length
		this.isMobile = isMobile()
	},
	data() {
		return {
			isMobile: false,
			curIndex: 0,
			totalSlides: 10
		}
	},
	methods: {
		next() {
			if (this.curIndex === this.totalSlides - 1) return this.curIndex = 0
			this.curIndex += 1
		},
		prev() {
			if (this.curIndex === 0) return this.curIndex = this.totalSlides - 1
			this.curIndex -= 1
		},
		slideImage(index) {
			return require(`../assets/sliders/${this.id}/${index}.jpg`)
		}
	}
}
</script>



<template>
<div class="article-slider" v-if="!isMobile">

	<div class="slider">
		<div class="inner">

			<div class="slide" v-for="(slide, index) in slides" :key="index" :class="{visible: index === curIndex}">
				<div class="image">
					<img :src="slideImage(index)">
					<div class="mask"></div>
				</div>
				<div class="name">
					<div class="main" v-if="slide.name1" v-html="slide.name1"></div>
					<div class="sub" v-if="slide.name2" v-html="slide.name2"></div>
				</div>
				<div class="about">
					<div class="about-inner" v-html="slide.text"></div>
				</div>
			</div>

			<div class="counter">{{ curIndex + 1 }} / {{ totalSlides }}</div>
			<div class="control left" @click="prev"><i class="fa fa-angle-left" aria-hidden="true"></i></div>
			<div class="control right" @click="next"><i class="fa fa-angle-right" aria-hidden="true"></i></div>

		</div>
	</div>

</div>
<div class="article-slider-m" v-else>

	<div class="inner clearfix">

		<div class="slide" v-for="(slide, index) in slides" :key="index" :class="{visible: index === curIndex}">
			<div class="image">
				<img :src="slideImage(index)">
				<div class="mask"></div>
			</div>
			<div class="name">
				<div class="main" v-if="slide.name1" v-html="slide.name1"></div>
				<div class="sub" v-if="slide.name2" v-html="slide.name2"></div>
			</div>
			<div class="about">
				<div class="about-inner" v-html="slide.text"></div>
			</div>
		</div>

	</div>

</div>
</template>

<style lang="less">
@import "../styles/colors.less";
@import "../styles/fonts.less";

.article-slider {
	width: 100%;
	height: 760px;
	background: #121212;
	position: relative;
}

.article-slider .bg {
	width: 100%;
	height: 340px;
	max-width: 1040px;
	position: absolute;
	top: 50%;
	left: 50%;
	background: #000;
	transform: translateX(-50%) translateY(-50%);
}

.article-slider .slider {
	width: 100%;
	max-width: 1040px;
	height: 100%;
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translateX(-50%) translateY(-50%);
}

.article-slider .slider .inner {
	width: 85%;
	height: 100%;
	padding: 0 7%;
}

.article-slider .slider .slide {
	width: 86%;
	height: 100%;
	position: absolute;
	opacity: 0;
	transition: all 300ms ease;

	&.visible {
		opacity: 1;
	}
}

.article-slider .slider .image {
	width: 580px;
	height: 525px;
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
}

.article-slider .slider .image img {
	width: 100%;
	position: absolute;
}

.article-slider .slider .image .mask {
	width: 100%;
	height: 100%;
	position: absolute;
	background: linear-gradient(to right, rgba(0,0,0,0) 0%, rgba(0,0,0,0.6) 100%);
}

.article-slider .slider .name {
	position: absolute;
	top: 40px;
	color: #fff;
	font-size: 23px;
}

.article-slider .slider .name .sub {
	font-size: 16px;
	font-family: @fontLava;
	font-style: italic;
	color: #a8a8a8;
}

.article-slider .slider .about {
	width: 400px;
	height: 100%;
	position: absolute;
	right: 0;
	color: #fff;
}

.article-slider .slider .about-inner {
	position: absolute;
	top: 50%;
	transform: translateY(-50%);
}

.article-slider .slider .about-inner .title {
	font-size: 16px;
	padding-bottom: 5px;
}

.article-slider .slider .text {
	font-size: 16px;
	font-family: @fontLava;
	font-style: italic;
	padding-bottom: 30px;
}

.article-slider .slider .text a {
	color: @red;
}

.article-slider .slider .text:last-child {
	padding-bottom: 0;
}

.article-slider .slider .counter {
	position: absolute;
	bottom: 70px;
	color: #fff;
}

.article-slider .control {
	width: 40px;
	height: 40px;
	position: absolute;
	top: 50%;
	margin-top: -20px;
	color: #fff;
	border: 2px solid #fff;
	border-radius: 20px;
	box-sizing: border-box;
	text-align: center;
	line-height: 32px;
	font-size: 26px;
	cursor: pointer;
	opacity: 0.7;
	transition: opacity 200ms ease;

	&.left {
		left: 0;
		text-indent: -2px;
	}

	&.right {
		right: 11px;
		text-indent: 2px;
	}

	&:hover {
		opacity: 1;
	}
}



// mobile slider
.article-slider-m {
	width: 100vw;
	background: #121212;
	color: #fff;

	.slide {
		width: 100vw;
		height: auto;
	}

	.image {
		width: 100%;
	}

	.image img {
		width: 100%;
	}

	.main {
		width: 90%;
		margin: 0 auto;
		color: #fff;
		font-size: 23px;
		padding-top: 20px;
	}

	.sub {
		width: 90%;
		margin: 0 auto;
		font-size: 16px;
		font-family: @fontLava;
		font-style: italic;
		color: #a8a8a8;
		padding-bottom: 20px;
	}

	.about {
		width: 90%;
		margin: 0 auto;
		font-size: 15px;
		padding-bottom: 40px;
	}

	.title {
		padding-top: 20px;
		padding-bottom: 10px;
		font-size: 20px;
	}



}


</style>



// WEBPACK FOOTER //
// ArticleSlider.vue?66fef598